<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
		<el-date-picker
			v-model="czsj"
			type="date"
			placeholder="选择充值时间">
		</el-date-picker>
		<el-input v-model="jgmc" placeholder="机构" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
		<el-button @click="searchJgCzjlPage" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
		<el-button type="primary" @click="jgCzjlExport" style="margin-bottom: 10px;" icon="el-icon-download">导出</el-button>
		</div>
		<el-table :data="tableData" border :header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }" style="width: 100%">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column label="充值时间" width="150px">
				<template slot-scope="scope">
					<span v-if="scope.row.czsj">{{formatDate(new Date(scope.row.czsj),'yyyy-MM-dd hh:mm')}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="jgglid" label="机构id"></el-table-column> -->
			<el-table-column prop="jgmc" label="机构"></el-table-column>
			<el-table-column prop="jglxmc" label="机构类型"></el-table-column>
			<el-table-column prop="ywmc" label="业务名称"></el-table-column>
			<el-table-column prop="fzr" label="负责人"></el-table-column>
			<el-table-column prop="sjh" label="手机号"></el-table-column>
			<el-table-column prop="czjf" label="充值积分"></el-table-column>
			<el-table-column prop="cjrmc" label="操作人"></el-table-column>
		</el-table>
		<el-pagination
			v-if="tableData.length"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="page.page"
			:page-sizes="[10, 20, 30, 40, 50]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="page.total">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'jgCzjlList',
	data() {
		return {
			userType: sessionStorage.getItem("userType"),
			czsj: '',//充值时间
			jgmc: '',//机构名称
			curDate: new Date().getTime(),
			tableData: [],
			page: { page: 1, size: 10, total: 0 },
			loading: false,
			jgglId: '',//机构id
      dlsglId: sessionStorage.getItem("dlsglId"), // 代理商id
      ywList: [], // 业务列表
		}
	},
	components:{},
	created() {
		//获取业务列表
		this.sltData();
		//获取机构充值记录分页列表
		this.findJgCzjlPage();
	},
	methods: {
    // 根据业务ID获取业务名称
    getYwName(ywcode) {
      const yw = this.ywList.find(item => item.ywcode === ywcode);
      return yw ? yw.ywmc : '';
    },
    // 下拉列表数据
    sltData() {
      // 业务列表
      this.$post("admin/YwController/list", { zt: 1 }).then(rep => {
        if (rep.code == 1) {
          this.ywList = rep.result.list;
        }
      })
    },
    // 搜索数据
    searchJgCzjlPage() {
      this.page.page = 1;
      this.findJgCzjlPage();
    },
    // 获取数据
    findJgCzjlPage() {
      var _this = this;
      var params = {
        czsj: _this.czsj?_this.formatDate(new Date(_this.czsj),'yyyy-MM-dd'):'',
        jgmc: _this.jgmc,
		    jgglId: _this.jgglId,
        dlsglId: _this.dlsglId,
        page: _this.page.page - 1,
        size: _this.page.size
      }
      _this.loading = true;
      _this.$post("jggl/JgglController/jgglCzjlPage", params).then(async rep => {
        _this.loading = false;
        if (rep.code == 1) {
          _this.tableData = rep.result.page.content;
          _this.page.total = rep.result.page.totalElements;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
		// 每页条数
		handleSizeChange(val) {
			this.page.size = val;
			this.findJgCzjlPage();
		},
		// 当前页
		handleCurrentChange(val) {
			this.page.page = val;
			this.findJgCzjlPage();
		},
    jgCzjlExport(){
      var access_token = sessionStorage.getItem("access_token");
      let url = "api/jggl/JgglController/jgglCzjlExport";
      url = url + "?access_token=" + access_token
          +"&czsj="+(this.czsj?this.formatDate(new Date(this.czsj),'yyyy-MM-dd'):'')
          +"&jgmc="+this.jgmc+"&jgglId="+this.jgglId
          +"&dlsglId="+this.dlsglId;
      console.log(url);
      window.location.href = url;
    },

	},
}
</script>

<style lang="less">
.school-manage {
  .el-table::before {
    display: none;
  }
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}

	.el-button--text {
		padding: 0
	}

	.el-pagination {
		height: 36px;
		text-align: right;
		margin-top: 20px;
	}
	.content{
		display: flex;
		flex-wrap: wrap;
		margin: 0 20px;
		.listData{
			width: 200px;
			margin-right: 80px;
			margin-bottom: 40px;
			.zt{
				border: 1px solid #ccc;
				background-color: #F2F2F2;
				border-radius: 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 150px;
				height: 70px;
				font-size: 16px;
				position: relative;
				i{
					position: absolute;
					left: 5px;
					top: -20px;
				}
				.el-icon-success{
					color: #67C23A;
				}
				.el-icon-error{
					color: #F56C6C;
				}
				.jiantou{
					position: absolute;
					right: -100px;
					width: 80px;
					height: 3px;
					background-color: #7F7F7F;
					display: flex;
					justify-content: end;
					align-items: center;
					span{
						position: absolute;
						right: -20px;
						width: 0;
						height: 0;
						border-style: solid;
						border-width: 10px 15px;
						border-color: transparent transparent transparent #7F7F7F;

					}
				}	
			}
			.mc{
				font-size: 14px;
				color: #7F7F7F;
				margin: 10px 0 3px;
			}
			.sj{
				font-size: 14px;
				color: #7F7F7F;
			}
		}
	}
	.xqtcCls{
		header{
			height: 50px;
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			padding: 0 30px;
			border-bottom: 1px solid #DCDFE6;
			span{
				font-weight: 500;
				font-size: 18px;
				color: #454545;
				margin-right: 25px;
			}
			div{
				padding: 0 8px;
				height: 28px;
				border-radius: 5px;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.shtg{
				background: #4CAF50;
			}
			.shbtg{
				background: #FA5151;
			}
			.wtj{
				background: #757575;
			}
			.shz{
				background: #FF9800;
			}
			.cha{
				width: 16px;
				position: absolute;
				right: 30px;
				cursor: pointer;
			}
		}
	}
}
</style>
